var map = {
	"./arrow-down-thin.svg": "92a8",
	"./arrow_back.svg": "c1dc",
	"./arrow_forward.svg": "9796",
	"./close.svg": "0572",
	"./delete_forever.svg": "2f5f",
	"./edit.svg": "c560",
	"./expand_more.svg": "a91b",
	"./file.svg": "6b64",
	"./loading-gray.svg": "25e4",
	"./loading.svg": "ad40",
	"./message-alert.svg": "914c",
	"./message.svg": "2931",
	"./monitor-gray-900.svg": "069e",
	"./monitor-white.svg": "f20f",
	"./payment-change-white.svg": "d03c",
	"./payment-change.svg": "6e64",
	"./percent.svg": "eb00",
	"./playlist_add_blue.svg": "1de7",
	"./playlist_add_red.svg": "8551",
	"./policy-change-white.svg": "58af",
	"./policy-change.svg": "46c6",
	"./policy-loan-white.svg": "1ed1",
	"./policy-loan.svg": "c008",
	"./qrcode.svg": "5a97",
	"./valid-email-error.svg": "be68",
	"./valid-email-valid.svg": "f8901",
	"./valid-email-warning.svg": "05cb",
	"./warning.svg": "080e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b713";